export const panelConstants = {
    MENU_REQUEST: 'MENU_REQUEST',
    MENU_SUCCESS: 'MENU_SUCCESS',
    MENU_FAILURE: 'MENU_FAILURE'
};
